export const Routes = {
  // pages
  Presentation: { path: "/dashboard/overview" },
  DashboardOverview: { path: "/dashboard" },
  Transactions: { path: "/transactions" },
  Settings: { path: "/settings" },
  DoctorList: { path: "/DoctorList" },
  DoctorCreate: { path: "/DoctorCreate" },
  DoctorOne: { path: "/Doctor/:id" },
  DoctorEdit: { path: "/DoctorEdit/:id" },
  LabList: { path: "/LabList" },
  LabCreate: { path: "/LabCreate" },
  LabOne: { path: "/Lab/:id" },
  LabEdit: { path: "/LabEdit/:id" },
  FacilityList: { path: "/FacilityList" },
  UserList: { path: "/UserList" },
  UserCreate: { path: "/UserCreate" },
  UserOne: { path: "/User/:id" },
  UserEdit: { path: "/UserEdit/:id" },
  PharmacyList: { path: "/PharmacyList" },
  PharmacyCreate: { path: "/PharmacyCreate" },
  PharmacyOne: { path: "/Pharmacy/:id" },
  PharmacyEdit: { path: "/PharmacyEdit/:id" },
  HPPList: { path: "/HPPList" },
  HPPCreate: { path: "/HPPCreate" },
  HPPOne: { path: "/HPP/:id" },
  HPPEdit: { path: "/HPPEdit/:id" },
  JobCreate: { path: "/JobCreate" },
  JobOne: { path: "/Job/:id" },
  JobEdit: { path: "/JobEdit/:id" },
  Careers: { path: "/CarrerList" },
  JobCreate: { path: "/JobCreate" },
  InterestedPerson: { path: "/InterestedPerson/:id" },
  UsersList: { path: "/UserListqewr" },
  AddProduct: {path: "/AddProduct"},
  ProductList: {path: "/ProductList"},
  ProductEdit: {path: "/ProductEdit/:id"},
  Blogs: {path: "/Blogs"},
  BlogList: {path: "/BlogList"},
  BlogEdit: {path: "/BlogEdit/:id"},
  BlogData: {path: "/BlogData/:id"},

  OrderManagement: { path: "/order-management" },
  OrderOne: { path: "/order/:id" },
  IssueCertificate: { path: "/issue-certificate" },

  Upgrade: { path: "/upgrade" },
  BootstrapTables: { path: "/tables/bootstrap-tables" },
  Billing: { path: "/billing" },
  Invoice: { path: "/invoice" },
  Signin: { path: "/" },
  Signup: { path: "/sign-up" },
  ForgotPassword: { path: "/forgot-password" },
  ResetPassword: { path: "/reset-password" },
  Lock: { path: "/lock" },
  NotFound: { path: "/404" },
  ServerError: { path: "/500" },

  // docs
  DocsOverview: { path: "/documentation/overview" },
  DocsDownload: { path: "/documentation/download" },
  DocsQuickStart: { path: "/documentation/quick-start" },
  DocsLicense: { path: "/documentation/license" },
  DocsFolderStructure: { path: "/documentation/folder-structure" },
  DocsBuild: { path: "/documentation/build-tools" },
  DocsChangelog: { path: "/documentation/changelog" },

  // components
  Accordions: { path: "/components/accordions" },
  Alerts: { path: "/components/alerts" },
  Badges: { path: "/components/badges" },
  Widgets: { path: "/widgets" },
  Breadcrumbs: { path: "/components/breadcrumbs" },
  Buttons: { path: "/components/buttons" },
  Forms: { path: "/components/forms" },
  Modals: { path: "/components/modals" },
  Navs: { path: "/components/navs" },
  Navbars: { path: "/components/navbars" },
  Pagination: { path: "/components/pagination" },
  Popovers: { path: "/components/popovers" },
  Progress: { path: "/components/progress" },
  Tables: { path: "/components/tables" },
  Tabs: { path: "/components/tabs" },
  Tooltips: { path: "/components/tooltips" },
  Toasts: { path: "/components/toasts" },
  WidgetsComponent: { path: "/components/widgets" },
};
